import { Pipe, PipeTransform } from '@angular/core';
import { mapSubtypeToTitle } from 'app/shared/utils/onboarding-utils';
import { AccountDocument, InternalAccount } from '../../../../projects/tilled-api-client/src';

@Pipe({
  name: 'informationRequestedPipe',
  standalone: true,
})
export class InformationRequestedPipe implements PipeTransform {
  constructor() {}

  /**
   *
   * @param account InternalAccount object
   * @param solid Whether or not the chip should be solid in color or not
   * @returns
   */
  transform(account: InternalAccount): string {
    const documentNames = this.getDocumentsStringArray(account.document_requests);
    const firstDocumentName = documentNames[0];
    const moreDocumentsLength = documentNames.length - 1;

    const finalText =
      moreDocumentsLength > 0 ? `${firstDocumentName} + ${moreDocumentsLength} more` : firstDocumentName;

    return finalText;
  }

  private getDocumentsStringArray(docs: AccountDocument[]): string[] {
    const docString: string[] = [];
    for (const doc of docs) {
      docString.push(mapSubtypeToTitle(doc.subtype, null, false));
    }
    return docString;
  }
}
